import {
  ON_CHANGE,
  ON_VALIDATION_ERRORS,
  ON_SUBMIT,
  ON_SUBMIT_SUCCESS,
  ON_SUBMIT_FAILURE,
} from '../constants';
import { Action } from '../types';
import { I18n } from '../helpers/i18n';
import { BusinessInfo } from '../types';

const initialState: BusinessInfo = {
  businessName: '',
  zipCode: '',
  city: '',
  streetAddress: '',
  website: '',
  physicalLocations: '',
  typeOfBusiness: '',
  categoryPds: '',
  fullName: '',
  phone: '',
  email: '',
  country: I18n.country,
  state: '',
  grouponSubscription: true,
  isLoading: false,
  isSubmitted: false,
  hasError: false,
  validations: {},
  freshRegistration: undefined,
  id: null,
  sf_id: null,
  dashboard: null,
};

const businessInfo = (state = initialState, action: Action) => {
  switch (action.type) {
    case ON_CHANGE:
      return { ...state, ...action.data };
    case ON_VALIDATION_ERRORS:
      return { ...state, ...action.data };
    case ON_SUBMIT:
      return { ...state, isLoading: true };
    case ON_SUBMIT_SUCCESS:
      return { ...state, isSubmitted: true, isLoading: false, ...action.data };
    case ON_SUBMIT_FAILURE:
      return { ...state, hasError: true, isLoading: false };
    default:
      return state;
  }
};

export default businessInfo;
